import {ReactElement} from 'react';
import {useTranslation} from 'react-i18next';
import notFoundHouse from 'assets/img/not-found-house.svg';
import {Wrapper, NotFoundIcon, Title, SecondText, Text} from './styled';

type ErrorViewProps = {
  title?: string;
  text?: string | ReactElement;
  secondText?: string;
};
function ErrorView({title, text, secondText}: Readonly<ErrorViewProps>) {
  const {t} = useTranslation();
  return (
    <Wrapper className="error-view">
      <NotFoundIcon
        src={notFoundHouse}
        width={147}
        height={132}
        className="error-view__icon"
      />
      <Title className="error-view__title">{title ?? t('link_not_valid')}</Title>
      <Text className="error-view__text">{text ?? t('not_found_has_missing')}</Text>
      <SecondText className="error-view__second-text">
        {secondText ?? t('not_found_make_sure')}
      </SecondText>
    </Wrapper>
  );
}

export {ErrorView};
